import Storage from './storage/Storage';
import ApiManager from './api/Manager';
import RBACManager from './rbac/Manager';
import * as Constants from './constants';
import EventEmitter from 'wolfy87-eventemitter';

import Store from '../../store';
import Events from './Events';

class Manager extends EventEmitter {
  constructor() {
    super();
    this.$http = new ApiManager();
    this.$storage = new Storage();
    this.$rbac = new RBACManager();
    this.initAuthorizationType();
    this.initRBAC();
    this.addStorageEventListeners();
  }

  initAuthorizationType() {
    let storage = this.$storage;
    if (!storage.isTokenExpired()
      && storage.getToken()
    ) {
      if (storage.getRefreshToken()) {
        this.setAuthorizationType(Constants.AUTHORIZED_AS_USER);
      } else {
        this.setAuthorizationType(Constants.AUTHORIZED_AS_APPLICATION);
      }
    } else {
      this.setAuthorizationType(Constants.UNAUTHORIZED);
    }
  }

  initRBAC() {
    if (!this.isGuest()) {
      this.$rbac.setUser(this.$storage.getUserInfo());
    }
  }

  addStorageEventListeners()  {
    this.$storage.on(Events.USER_INFO_EXPIRED, () => {
        this.reinitUser();
    });
  }

  setAuthorizationType(...args) {
    Store.dispatch('auth/setAuthorizationType', ...args);
  }

  async getToken() {
    let storage = this.$storage;
    if (storage.isTokenExpired()) {
      storage.removeToken(true);
      this.setAuthorizationType(Constants.UNAUTHORIZED);
      this.$rbac.flush();
      try {
        let refreshToken = storage.getRefreshToken();
        if (refreshToken) {
          await this.refresh(refreshToken);
        } else {
          await this.authorizeAsApp();
        }
      } catch (e) {
        await this.unauthorize();
      }
    }
    return storage.getToken();
  }

  getTokenSync() {
    let storage = this.$storage;
    return storage.getToken();
  }

  async unauthorize() {
    this.emit(Events.BEFORE_UNAUTHORIZE);
    let result = this.$storage.removeToken();
    this.setAuthorizationType(Constants.UNAUTHORIZED);
    this.$rbac.flush();
    this.$storage.clear();
    this.emit(Events.AFTER_UNAUTHORIZE);
    await this.authorizeAsApp();
    return result;
  }

  async authorize(methodName, ...args) {
    try {
      let {data: response} = await this.$http[methodName](...args);
      let {access_token: token, expires_in: expiresIn, refresh_token: refreshToken} = response.data;
      expiresIn = (new Date()).getTime() + (expiresIn * 1000);
      this.$storage.setToken(
        token,
        expiresIn,
        refreshToken,
      );
      return true;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async authorizeAsApp() {
    let result = await this.authorize('getAppToken');
    this.setAuthorizationType(Constants.AUTHORIZED_AS_APPLICATION);
    return result;
  }

  async authorizeAsUser(methodName, ...args) {
    let result = await this.authorize(methodName, ...args);
    this.setAuthorizationType(Constants.AUTHORIZED_AS_USER);
    let userInfo = await this.$rbac.initUser();
    this.$storage.setUserInfo(userInfo);
    return result;
  }
  async reinitUser() {
    let userInfo = await this.$rbac.initUser();
    this.$storage.setUserInfo(userInfo);
  }

  login(username, password) {
    return this.authorizeAsUser('getUserToken', {username, password});
  }

  refresh(token) {
    return this.authorizeAsUser('refresh', token);
  }

  isAuthorized() {
    return Store.getters['auth/isAuthorized'];
  }

  isGuest() {
    return Store.getters['auth/isGuest'];
  }

  isBCBA() {
    return this.$rbac.isBCBA();
  }

  isCurator() {
    return this.$rbac.isCurator();
  }

  isTherapist() {
    return this.$rbac.isTherapist();
  }

  isClient() {
    return this.$rbac.isClient();
  }

  can(...args) {
    return this.$rbac.can(...args);
  }

  getUserInfo() {
    if (!this.isGuest()) {
      return this.$storage.getUserInfo();
    } else {
      return null;
    }
  }

  isMensurationForbidden() {
    return this.$rbac.isMensurationForbidden();
  }
}

export default new Manager();



// WEBPACK FOOTER //
// ./src/common/auth/Manager.js